export const PHONES = [
  { id: "1", label: "924 368 988", wa: "https://wa.me/351924368988", tel: "tel:+351924368988" },
  { id: "2", label: "969 385 814", wa: "https://wa.me/351969385814", tel: "tel:+351969385814" },
];

export const ADDRESS = "Av. Dom Vicente Afonso Valente D, 2625-095 Póvoa de Santa Iria";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=RS+Beauty+Salon+Av.+Dom+Vicente+Afonso+Valente+D+2625-095+P%C3%B3voa+de+Santa+Iria";

export const SERVICES = [
  {
    n: "01",
    title: "Cabeleireiro",
    text: "Cortes, coloração, madeixas e balayage, brushing e penteados. Cada detalhe pensado para o seu estilo.",
    tags: ["Corte", "Coloração", "Balayage", "Brushing"],
    img: "/img/cabelo.webp",
  },
  {
    n: "02",
    title: "Unhas",
    text: "Manicure, gel e nail art com acabamento impecável — do nude clássico aos detalhes dourados.",
    tags: ["Manicure", "Gel", "Nail art", "Pedicure"],
    img: "/img/unhas-escuras.webp",
  },
  {
    n: "03",
    title: "Estética",
    text: "Cuidados de beleza num ambiente calmo e acolhedor, para sair a sentir-se renovada.",
    tags: ["Cuidados de rosto", "Sobrancelhas", "Bem-estar"],
    img: "/img/sobrancelhas.webp",
    pos: "50% 45%",
  },
];

export const REVIEWS = [
  { name: "Jessika Meireles", text: "Adorei o espaço, ambiente acolhedor, o atendimento maravilhoso, a cabeleireira Rejane é impecável no trabalho, voltarei a desfrutar dos serviços com certeza." },
  { name: "Cliente Google", text: "Não confio as minhas mãos e o meu cabelo a mais ninguém!" },
  { name: "Rahul Sharma", text: "O salão é muito bom e oferece um ótimo atendimento, com diversos serviços, como unhas e cabelo. O ambiente é excelente." },
  { name: "Cliente Google", text: "O ambiente é bonito, agradável e transmite uma sensação de tranquilidade." },
  { name: "Cliente Google", text: "A Rafaela é uma excelente profissional, cuidadosa e muito querida." },
];
